import { Component, OnInit, Inject } from '@angular/core';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { UntypedFormGroup, UntypedFormControl, ValidatorFn, AbstractControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserService } from '../../services/user.service';
import { BehaviorSubject } from 'rxjs';
import { MODAL_CONTROLLER, MODAL_DATA, ModalController, INotificationSettings } from 'shared';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { ModalComponent } from '../../../../../shared/src/lib/components/modal/modal.component';
import { AsyncPipe } from '@angular/common';
import { ModalContentComponent } from '../../../../../shared/src/lib/components/modal-content/modal-content.component';
import { LoadingSpinnerComponent } from '../../../../../shared/src/lib/components/loading-spinner/loading-spinner.component';
import { InputComponent } from '../../../../../shared/src/lib/components/input/input.component';
import { ModalButtonsComponent } from '../../../../../shared/src/lib/components/modal-buttons/modal-buttons.component';
import { ModalButtonComponent } from '../../../../../shared/src/lib/components/modal-button/modal-button.component';
import { TextButtonComponent } from '../../../../../shared/src/lib/components/text-button/text-button.component';


export function phoneNumberValidator(): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    const validator = parsePhoneNumberFromString(control.value);
    const valid = validator && validator.isValid();
    if (valid) {
      return null;
    } else {
      return {
        phone: false
      };
    }
  };
}


@Component({
    selector: 'app-two-factor-verification-flow-modal',
    templateUrl: './two-factor-verification-flow-modal.component.html',
    styleUrls: ['./two-factor-verification-flow-modal.component.scss'],
    imports: [ModalComponent, ModalContentComponent, LoadingSpinnerComponent, FormsModule, ReactiveFormsModule, InputComponent, ModalButtonsComponent, ModalButtonComponent, TextButtonComponent, TranslateModule, AsyncPipe]
})
export class TwoFactorVerificationFlowModalComponent {

  public notificationsettings: INotificationSettings;

  public seconds = 30;
  public showPhoneNumberError = false;

  public error$ = new BehaviorSubject('');

  public loading = false;
  public step: 'phone' | 'code' | 'success' = 'phone';

  public form = new UntypedFormGroup({
    mobile: new UntypedFormControl('', [Validators.required, phoneNumberValidator(), Validators.pattern('[0-9+]+')]),
    verification: new UntypedFormControl('', [Validators.required, Validators.maxLength(6), Validators.minLength(6), Validators.pattern('[0-9]+')])
  });

  constructor(
    @Inject(MODAL_CONTROLLER)  private controller: ModalController<void>,
    @Inject(MODAL_DATA) private modalData: INotificationSettings,
    private userService: UserService,
    private translate: TranslateService
  ) {
    this.notificationsettings = modalData;

    if (this.modalData.mobile) {
      this.form.controls.mobile.setValue(modalData.mobile);
    }
  }

  startVerification() {
    this.loading = true;
    if (this.modalData.mobile === this.form.value.mobile && this.modalData.mobileValidatedState === 'Validated') {
      this.controller.dismiss();
    } else {
      this.userService.setNotificationPreferences({
        ...this.notificationsettings,
        mobile: this.form.value.mobile,
      })
          .subscribe(() => {
            this.step = 'code';
            this.loading = false;
            this.startCountdown();
          }, err => {

          });
    }
  }

  verifyCode() {
    this.loading = true;

    this.userService.sendConfirmationCode(this.form.controls.verification.value)
      .subscribe(() => {
        this.step = 'success';
        this.loading = false;
      }, (err) => {
        this.loading = false;
        this.error$.next(this.translate.instant('two-factor-verification-flow-modal.incorrect-verification-code'));
      });
  }

  done() {
    this.controller.complete();
  }

  startCountdown() {
    this.seconds = 60;
    const interval = setInterval(() => {
      this.seconds -= 1;

      if (this.seconds === 0) {
        clearInterval(interval);
      }
    }, 1000);
  }

  resendCode() {
    this.userService.resendConfirmationCode().subscribe(() => {
      this.startCountdown();
    }, err => {
      this.error$.next(this.translate.instant('two-factor-verification-flow-modal.code-resent-too-often'));
    });
  }

  dismiss() {
    this.controller.dismiss();
  }
}
